import(/* webpackMode: "eager" */ "/vercel/path0/src/app/client-portal/page.tsx");
